import React from 'react';
import './styles/hjemmesider.css';
import SEO from '../../components/SEO';
import Header from '../../components/header';
import Footer from '../../components/footer';
import ArtikelSektion from '../../components/artikelsektion';
import Testimonials from '../../components/testimonials';
import HjemmesideFAQ from '../../components/HjemmesideFAQ';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';

const HjemmesiderHero = () => {
  return (
    <section className="hjemmesider-hero">
      <div className="container">
        <div className="hjemmesider-hero-content">
          <div className="hjemmesider-hero-text">
            <div className="hjemmesider-hero-badge">
              <span>Professionelle hjemmesider</span>
            </div>
            <h1 className="hjemmesider-hero-title">
              En <span className="hjemmesider-hero-accent">hjemmeside</span> designet til jeres kunder
            </h1>
            <p className="hjemmesider-hero-description">
              Når en potentiel kunde lander på jeres hjemmeside, stiller de sig selv en række ubevidste spørgsmål: Føles det her rigtigt? Er det let at finde information? Kan jeg stole på dem?
              <br /><br />
              Vores arbejde handler om at besvare alle de spørgsmål med et rungende "ja". Vi bygger en digital oplevelse, der er så ubesværet og overbevisende, at den aktivt guider jeres kunder fra første indtryk til en positiv handling – og styrker deres tillid til jer undervejs.
            </p>
            <div className="hjemmesider-hero-stats">
              <div className="hjemmesider-hero-stat">
                <div className="hjemmesider-hero-stat-number">150+</div>
                <div className="hjemmesider-hero-stat-label">Hjemmesider leveret</div>
              </div>
              <div className="hjemmesider-hero-stat">
                <div className="hjemmesider-hero-stat-number">4.4★</div>
                <div className="hjemmesider-hero-stat-label">Kundetilfredshed</div>
              </div>
              <div className="hjemmesider-hero-stat">
                <div className="hjemmesider-hero-stat-number">7 dage</div>
                <div className="hjemmesider-hero-stat-label">Gennemsnitlig leveringstid</div>
              </div>
            </div>
            <div className="hjemmesider-hero-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/kontakt"
                icon={<CTAIkoner.ArrowRight />}
              >
                Få din hjemmeside
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/priser#prisudregner"
                icon={<CTAIkoner.Search />}
              >
                Se priser
              </CTAKnap>
            </div>
          </div>
          <div className="hjemmesider-hero-visual">
            <div className="hjemmesider-hero-image">
              <div className="hjemmesider-hero-mockup">
                <div className="browser-window">
                  <div className="browser-top">
                    <div className="browser-controls">
                      <div className="control-dot red"></div>
                      <div className="control-dot yellow"></div>
                      <div className="control-dot green"></div>
                    </div>
                    <div className="address-bar">
                      <span>www.dinvirksomhed.dk</span>
                    </div>
                  </div>
                  <div className="browser-content">
                    <div className="page-header">
                      <div className="logo-placeholder"></div>
                      <div className="nav-menu">
                        <div className="nav-dot"></div>
                        <div className="nav-dot"></div>
                        <div className="nav-dot"></div>
                      </div>
                    </div>
                    <div className="page-hero">
                      <div className="hero-title-block">
                        <div className="title-line main"></div>
                        <div className="title-line sub"></div>
                      </div>
                      <div className="hero-button-placeholder"></div>
                    </div>
                    <div className="page-content">
                      <div className="content-section">
                        <div className="content-block"></div>
                        <div className="content-block"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const HjemmesiderFeatures = () => {
  return (
    <section className="hjemmesider-features">
      <div className="container">
        <div className="hjemmesider-features-content">
          <div className="hjemmesider-features-left">
            <div className="hjemmesider-features-badge">
              <span>Komplet løsning</span>
            </div>
            <h2 className="hjemmesider-features-title">
              Mere end bare en hjemmeside - en <span className="hjemmesider-accent">digital partner</span>
            </h2>
            <p className="hjemmesider-features-description">
              Vores tilgang er bygget på tre grundpiller: En klar strategi, der tager udgangspunkt i jeres forretningsmål, et intuitivt og konverterende design, der guider jeres brugere, og en solid teknisk platform, der sikrer hastighed, <a href="https://web.dev/why-https-matters/" target="_blank" rel="noopener noreferrer">sikkerhed</a> og synlighed på Google.
            </p>
            
            <div className="hjemmesider-core-features">
              <div className="core-feature">
                <div className="core-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7V10C2 16 6 20.5 12 22C18 20.5 22 16 22 10V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="core-feature-content">
                  <h3>Responsivt & Mobilvenligt</h3>
                  <p>Perfekt på alle enheder - fra mobil til desktop</p>
                </div>
              </div>

              <div className="core-feature">
                <div className="core-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="core-feature-content">
                  <h3>Lynhurtig Performance</h3>
                  <p>Optimeret kode for bedste brugeroplevelse</p>
                </div>
              </div>

              <div className="core-feature">
                <div className="core-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 11H15M9 15H15M17 21L12 16L7 21V5A2 2 0 0 1 9 3H15A2 2 0 0 1 17 5V21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="core-feature-content">
                  <h3>SEO Optimeret</h3>
                  <p>Sørger for synlighed i søgemaskiner</p>
                </div>
              </div>
            </div>
          </div>

          <div className="hjemmesider-features-right">
            <div className="hjemmesider-features-visual">
              <div className="features-mockup">
                <div className="responsive-showcase">
                  <div className="desktop-frame">
                    <div className="desktop-window">
                      <div className="window-header">
                        <div className="window-controls">
                          <span className="control red"></span>
                          <span className="control yellow"></span>
                          <span className="control green"></span>
                        </div>
                        <div className="window-title">www.dinvirksomhed.dk</div>
                      </div>
                      <div className="window-body">
                        <div className="site-header">
                          <div className="site-logo"></div>
                          <div className="site-nav">
                            <div className="nav-item"></div>
                            <div className="nav-item"></div>
                            <div className="nav-item active"></div>
                          </div>
                        </div>
                        <div className="site-hero">
                          <div className="hero-text">
                            <div className="hero-title"></div>
                            <div className="hero-subtitle"></div>
                            <div className="hero-button"></div>
                          </div>
                          <div className="hero-image"></div>
                        </div>
                        <div className="site-content">
                          <div className="content-grid">
                            <div className="content-box"></div>
                            <div className="content-box"></div>
                            <div className="content-box"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mobile-frame">
                    <div className="mobile-device">
                      <div className="device-screen">
                        <div className="status-bar">
                          <div className="time">9:41</div>
                          <div className="indicators">
                            <div className="signal"></div>
                            <div className="wifi"></div>
                            <div className="battery"></div>
                          </div>
                        </div>
                        <div className="app-content">
                          <div className="mobile-nav">
                            <div className="menu-btn"></div>
                            <div className="mobile-logo"></div>
                            <div className="search-btn"></div>
                          </div>
                          <div className="mobile-hero">
                            <div className="mobile-title"></div>
                            <div className="mobile-subtitle"></div>
                            <div className="mobile-button"></div>
                          </div>
                          <div className="mobile-content">
                            <div className="content-card">
                              <div className="card-image"></div>
                              <div className="card-text"></div>
                            </div>
                            <div className="content-card">
                              <div className="card-image"></div>
                              <div className="card-text"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="hjemmesider-features-cta">
          <div className="hjemmesider-features-cta-text">
            <p>Klar til at tage næste skridt?</p>
          </div>
          <div className="hjemmesider-features-cta-buttons">
            <CTAKnap 
              variant="primary" 
              href="/priser"
              icon={<CTAIkoner.Search />}
            >
              Se priser
            </CTAKnap>
            <CTAKnap 
              variant="outline" 
              href="/cases"
              icon={<CTAIkoner.ArrowRight />}
            >
              Se vores cases
            </CTAKnap>
            <CTAKnap 
              variant="outline" 
              href="/seo"
              icon={<CTAIkoner.BarChart />}
            >
              Læs om SEO
            </CTAKnap>
          </div>
        </div>
      </div>
    </section>
  );
};

const HjemmesiderProcess = () => {
  return (
    <section className="hjemmesider-process">
      <div className="container">
        <div className="hjemmesider-process-layout">
          <div className="process-visual">
            <div className="process-illustration">
              <div className="illustration-layer layer-1">
                <div className="floating-element element-1"></div>
                <div className="floating-element element-2"></div>
                <div className="floating-element element-3"></div>
              </div>
              <div className="illustration-layer layer-2">
                <div className="code-editor">
                  <div className="editor-header">
                    <div className="editor-tabs">
                      <div className="tab active">index.html</div>
                      <div className="tab">style.css</div>
                      <div className="tab">script.js</div>
                    </div>
                  </div>
                  <div className="editor-content">
                    <div className="code-line">
                      <span className="code-tag">&lt;div</span>
                      <span className="code-attr">class=</span>
                      <span className="code-string">"hero"</span>
                      <span className="code-tag">&gt;</span>
                    </div>
                    <div className="code-line indent">
                      <span className="code-tag">&lt;h1&gt;</span>
                      <span className="code-text">Welcome</span>
                      <span className="code-tag">&lt;/h1&gt;</span>
                    </div>
                    <div className="code-line indent">
                      <span className="code-tag">&lt;p&gt;</span>
                      <span className="code-text">Professional website</span>
                      <span className="code-tag">&lt;/p&gt;</span>
                    </div>
                    <div className="code-line">
                      <span className="code-tag">&lt;/div&gt;</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="process-content">
            <div className="process-header">
              <h2 className="process-title">
                En proces, der skaber <span className="hjemmesider-accent">tryghed og resultater</span>
              </h2>
              <p className="process-description">
                Et succesfuldt projekt kræver både klar retning fra os og dyb indsigt fra jer. Vores proces er designet til at kombinere vores tekniske og strategiske ekspertise med jeres unikke forretningsviden. Vi styrer processen, så I kan have fuld tillid til, at alle beslutninger træffes med ét formål: at skabe det bedst mulige resultat for jer.
              </p>
            </div>

            <div className="process-timeline">
              <div className="timeline-item">
                <div className="timeline-marker">
                  <span className="timeline-number">1</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-title">Fælles afsæt: Forståelse og strategi</h3>
                  <p className="timeline-description">
                    Alt meningsfuldt arbejde starter med at lytte. Vi dedikerer den indledende fase til at forstå jeres verden – jeres mål, jeres kunder og jeres marked. Sammen skaber vi et klart, strategisk fundament, der fungerer som projektets rettesnor.
                  </p>
                  <div className="timeline-highlights">
                    <span>Forretningsforståelse</span>
                    <span>Strategisk fundament</span>
                    <span>Klar retning</span>
                  </div>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">
                  <span className="timeline-number">2</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-title">Løsningen tager form: Design og struktur</h3>
                  <p className="timeline-description">
                    Med strategien som fundament begynder udformningen af løsningen. Her trækker vi på vores erfaring til at designe en intuitiv struktur og en professionel brugeroplevelse. Vores designvalg er altid begrundet i det overordnede mål, og vi holder jer orienteret om de vigtige beslutninger undervejs.
                  </p>
                  <div className="timeline-highlights">
                    <span>Intuitiv struktur</span>
                    <span>Professionel UX</span>
                    <span>Strategisk design</span>
                  </div>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">
                  <span className="timeline-number">3</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-title">Præcis udførelse: Udvikling og test</h3>
                  <p className="timeline-description">
                    Her bliver design og strategi omdannet til en fuldt funktionel platform. Hver linje kode skrives med et kompromisløst fokus på kvalitet, hastighed og sikkerhed. En grundig testfase sikrer, at det endelige produkt er solidt og lever op til de højeste standarder.
                  </p>
                  <div className="timeline-highlights">
                    <span>Kvalitet og hastighed</span>
                    <span>Sikkerhed i fokus</span>
                    <span>Grundig test</span>
                  </div>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">
                  <span className="timeline-number">4</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-title">Fra Projekt til Færdigt Produkt</h3>
                  <p className="timeline-description">
                    Processen kulminerer med den fejlfri lancering af jeres nye, færdigbyggede hjemmeside. Ved projektets afslutning har I et fuldt funktionelt og professionelt digitalt aktiv.
                    <br /><br />
                    Efter lancering er den videre drift jeres valg. For virksomheder, der ønsker fuld tryghed og professionel vedligeholdelse, tilbyder vi et fast serviceabonnement. Her varetager vores team al fremtidig drift, så I kan være sikre på, at jeres platform altid er opdateret med korrekte information og design.
                  </p>
                  <div className="timeline-highlights">
                    <span>Fejlfri lancering</span>
                    <span>Professionel vedligeholdelse</span>
                    <span>Fast serviceabonnement</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const HjemmesiderSEO = () => {
  return (
    <section className="hjemmesider-seo">
      <div className="container">
        <div className="hjemmesider-seo-content">
          <div className="hjemmesider-seo-text">
            <h2 className="hjemmesider-seo-title">
              Fra et solidt fundament til en <span className="hjemmesider-accent">stærk position</span>
            </h2>
            <p className="hjemmesider-seo-description">
              Enhver hjemmeside, vi bygger, har et stærkt teknisk SEO-fundament. Det er jeres sikkerhed for, at søgemaskiner som Google kan læse og forstå jeres side fra dag ét.
              <br /><br />
              Men for virksomheder, der ønsker at udnytte deres fulde potentiale og opnå en markant stærkere position i markedet, er et dedikeret SEO-forløb det næste logiske skridt. Her arbejder vi strategisk med at øge jeres synlighed, tiltrække flere relevante kunder og omdanne jeres online tilstedeværelse til en markant konkurrencefordel.
            </p>
            <div className="hjemmesider-seo-cta">
              <CTAKnap 
                variant="outline" 
                href="/seo"
                icon={<CTAIkoner.BarChart />}
              >
                Se SEO-pakker
              </CTAKnap>
            </div>
          </div>
          
          <div className="hjemmesider-seo-visual">
            <div className="search-simple">
              <div className="search-header">
                <div className="search-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="8" stroke="#9CA3AF" strokeWidth="2"/>
                    <path d="m21 21-4.35-4.35" stroke="#9CA3AF" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="search-query">din virksomhed</div>
              </div>
              <div className="search-results-simple">
                <div className="result-item top">
                  <div className="result-dot"></div>
                  <div className="result-line long"></div>
                </div>
                <div className="result-item">
                  <div className="result-dot"></div>
                  <div className="result-line"></div>
                </div>
                <div className="result-item">
                  <div className="result-dot"></div>
                  <div className="result-line short"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const HjemmesiderPage = () => {
  return (
    <>
      <SEO
        title="Professionel Hjemmeside - Bygget til Vækst & Salg | Parla Branding"
        description="Få mere end et pænt design. Vores strategiske proces sikrer en hurtig, sikker og konverterende hjemmeside, der giver jer et markant forspring foran konkurrenterne."
        keywords="professionel hjemmeside, hjemmeside til vækst, konverterende hjemmeside, strategisk webdesign, hjemmeside forspring, salgsoptimeret hjemmeside"
        canonicalUrl="https://www.parlabranding.dk/hjemmesider"
        isService={true}
        serviceData={{
          name: "Professionel Hjemmeside Design",
          description: "Vi designer og udvikler professionelle hjemmesider for danske virksomheder",
          price: "12000"
        }}
      />
      
      <Header />
      <HjemmesiderHero />
      <Testimonials />
      <HjemmesiderFeatures />
      <HjemmesiderProcess />
      <HjemmesiderSEO />
      <ArtikelSektion />
      <HjemmesideFAQ />
      <Footer />
    </>
  );
};

export default HjemmesiderPage;
